module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/proposes"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/propose_task_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose Title')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Propose Title Detail')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose Title Detail')))]), (_vm.callbackFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.proposeTaskDetail.attributes['task-title']))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(1), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.proposeTaskDetail.attributes['task-state-conversion']))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(2), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.proposeTaskDetail.attributes['task-start-date'])))]), _c('span', [_vm._v(" 〜 ")]), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.proposeTaskDetail.attributes['task-end-date'])))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/propose_task_list"
    }
  }, [_vm._v("戻る")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("タイトル")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("状態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("公開年月日")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32488ea4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose-task-detail.pug
// module id = 820
// module chunks = 1